module.exports = __webpack_public_path__ + "img/401.8e0835a1.jpg";